export enum SysExternalWebUserType {
  SSICSClientPortal = 1,
  SSICSASFPortal = 2,
}
